<template>
  <div>
    <div class="productContent">
      <h2>Commodities</h2>
      <div class="onOffSwitch">
        <!-- <div class="switchTxt">
                    <label class="switch active">
                        <span class="optionSelLeft active">Fruits</span>
                        <span class="optionSelRight">Vegetables</span>
                        <input type="checkbox" />
                        <span class="slider round"></span>
                    </label>
        </div>-->
      </div>
      <div class="productSearch">
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Quick Search"
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
          >
          <div class="input-group-append">
            <span class="input-group-text" id="basic-addon2">
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="productFilter">
            <div class="filterOptions">
                <label>Commodity</label>
                <div class="dropdown comm-drp-dwm  dropdown-toggle" style="width : 250px;">
                    <input type="text" value="Potato" class="btn btn-primary" data-toggle="dropdown" readonly>
                    <div class="dropdown-menu comm-drp-dwm">
                        <a class="dropdown-item bdr-btm-none" href="#" style="font-size : 20px;">Potato</a>
                    </div>
                </div>
            </div>
            <div class="filterOptions">
                <button class="applyBtn">apply</button>
            </div>
    </div>-->
    <div class="productSlider">
      <div id="demo" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Indicators -->
        <!-- <ul class="carousel-indicators">
                    <li data-target="#demo" data-slide-to="0" class="active"></li>
                    <li data-target="#demo" data-slide-to="1"></li>
                    <li data-target="#demo" data-slide-to="2"></li>
                    <li data-target="#demo" data-slide-to="3"></li>
        </ul>-->

        <!-- The slideshow -->
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="row">
              <div class="col-lg-12">
                <div class="potRow1">
                  <div class="p-2">
                    <div class="productList shadow" v-on:click="openTemplate('potato')"></div>
                    <p class="product-name text-center">Potato</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    

  </div>
</template>
<style src= "@/assets/css/bootstrap.min.css" />
<style src= "@/assets/css/style.css" />
<style src= "@/assets/css/print.css" media="print" />
<style scoped>
.midSection .productSlider .carousel-control-prev,
.midSection .productSlider .carousel-control-next {
  bottom: -72px !important;
}

.midSection .productSlider {
  padding: 20px 20px 93px !important;
}

.midSection .navListLeft {
  height: 634px !important;
}

#demo.carousel {
  padding-bottom: 20px !important;
}

#demo .carousel-inner {
  padding-bottom: 10px !important;
}

.carousel-control-next-icon img,
.carousel-control-prev-icon img {
  vertical-align: top !important;
}

.midSection .productSlider .carousel-indicators .active {
  top: -3px !important;
}

.midSection .productSlider .carousel-indicators {
  bottom: -260px !important;
}

.productSlider { /* styles changed here */
  height: 71.5vh;
  overflow: auto;
}
</style>

<script>
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState, mapActions } from "vuex";


@Component({})
export default class SelectCommodity extends Vue {

  openTemplate(commodity) {
    this.$store.dispatch("showNonEditableSamples", false);
    this.$store.dispatch("selectCommodity", commodity);
    // this.$store.dispatch("showTemplate");
    this.$router.push('/app/secure/inspectionTemplate/generalInfo/'+commodity)
    this.$router.go()
  }
}
</script>